import type { ChecklistRun, ChecklistRunWithItems } from './types';

export function runProgress(run: ChecklistRun): number | null {
  // List endpoints enrich each row with `itemCount` + `doneCount` so
  // we can render real progress without fanning out N detail fetches.
  // When those aren't present (older clients, hand-built fixtures),
  // return null and the caller renders an indeterminate bar.
  if (run.itemCount == null || run.doneCount == null) return null;
  if (run.itemCount === 0) return 0;
  return Math.round((run.doneCount / run.itemCount) * 100);
}

export function runProgressFrom(detail: ChecklistRunWithItems): number {
  if (detail.items.length === 0) return 0;
  const done = detail.items.filter((i) => i.status === 'done' || i.status === 'skipped').length;
  return Math.round((done / detail.items.length) * 100);
}

export function runStatusLabel(run: ChecklistRun): string {
  if (run.status === 'completed') return 'Completed';
  if (run.status === 'in_progress') return 'In progress';
  if (run.status === 'archived') return 'Archived';
  if (run.status === 'skipped') return 'Skipped';
  return 'Not started';
}
